import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import {
    FaClock,
    FaDribbble,
    FaFacebookF,
    FaLinkedinIn,
    FaMap,
    FaPlus,
    FaTwitter,
    FaYoutube
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/logo.webp';

function OffsetMenu({ className, handleOffset }) {
    return (
        <div className={className}>
            <span id="offset-menu-close-btn">
                <FaPlus onClick={handleOffset} />
            </span>
            <div className="offset-menu-wrapper text-white">
                <div className="offset-menu-header">
                    <div className="offset-menu-logo">
                        <Link to="/">
                            <img src={logo} alt="Work Express" />
                        </Link>
                    </div>
                </div>
                <div className="offset-menu-section">
                    <h3>Despre Noi</h3>
                    <p>
                        Work Express este o companie dinamică și inovatoare, fondată în 2017, dedicată furnizării soluțiilor eficiente și moderne pentru nevoile clienților noștri. Cu o echipă pasionată și orientată spre excelență, ne străduim să oferim rezultate de înaltă calitate.
                    </p>
                    <Link to="/contact" className="theme-btn mt-30">
                        Solicită Ofertă
                    </Link>
                </div>
                <div className="offset-menu-section">
                    <h3>Informații de Contact</h3>
                    <ul>
                        <li>
                            <span>
                                <FaMap />
                            </span>
                            București, România
                        </li>
                        <li>
                            <span>
                                <AiOutlinePhone />
                            </span>
                            0724.273.258
                        </li>
                        <li>
                            <span>
                                <AiOutlineMail />
                            </span>
                            office@reparatiiasfalt.ro
                        </li>
                        <li>
                            <span>
                                <FaClock />
                            </span>
                            Luni - Vineri: 08:00 - 18:00
                        </li>
                        <li>
                            <span>
                                <FaClock />
                            </span>
                            Sâmbătă - Duminică: La cerere
                        </li>
                    </ul>
                </div>
                <div className="offset-menu-footer">
                    <div className="offset-menu-social-icon">
                        <a href="https://facebook.com">
                            <FaFacebookF />
                        </a>
                        <a href="https://twitter.com">
                            <FaTwitter />
                        </a>
                        <a href="https://linkedin.com">
                            <FaLinkedinIn />
                        </a>
                        <a href="https://instagram.com">
                            <FaDribbble />
                        </a>
                        <a href="https://youtube.com">
                            <FaYoutube />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OffsetMenu;
